/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the product Features And Benefits Module
	 * -----------------------------------------
	 * @section product_features_and_benefits_js
	 ********************************************/
	(function ProductFeaturesAndBenefitsModule() {
		var $featuresBenefitsModules;

		/********************************************
		.* Attach
		.* -----------------------------------------
		.* Attach events to each module instance
		.********************************************/
		function attachEvents() {
			$featuresBenefitsModules = rp$('.product-features-benefits-module');

			rp$.each($featuresBenefitsModules, function Listing_Iterator(idx, featuresAndBenefitsModule) {
				var $featuresAndBenefitsModule = rp$(featuresAndBenefitsModule);
				var wrapper = $featuresAndBenefitsModule.find('.more-features-container');
                var readMoreButton = $featuresAndBenefitsModule.find('.read-more');

				$featuresAndBenefitsModule.on('click', '.read-more', function Expand_Features_And_Benefits() {
					if (wrapper.hasClass('in')) {
						wrapper.removeClass('in');
                        readMoreButton.find('strong').text(window.javascriptContent.read_more);
					} else {
						wrapper.addClass('in');
                        readMoreButton.find('strong').text(window.javascriptContent.read_less);
					}
				});
			});
		}

		$onReady({
			rp$, window,
			label: 'product_features_and_benefits',
			fn: function () {
				attachEvents();
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
